import React, { Component } from 'react'
import Panel from '@common/Panel'
import { inject, observer } from 'mobx-react'
import { dGet } from '@core/utils'
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'
import { toJS } from 'mobx'
import styles from './style.module.less'
import { CheckCircleOutlined } from '@ant-design/icons'
import isEmpty from 'lodash/isEmpty'

@inject('store')
@observer
export default class extends Component {
  state = {
    visible: false
  }

  isChartDataNotReady = taskPageData => {
    const list = toJS(taskPageData.exposureList)
    return Array.isArray(list) && list.length == 0
  }

  getStatus = taskPageData => {
    let supportEndTime = dGet(taskPageData, 'merchantExtends.supportEndTime')
    let { completeCount, undoneCount, completionRate, exposureList, caseUrl } =
      taskPageData || {}

    const examples = (
      <a
        style={{ textDecoration: 'underline', color: '#000' }}
        href={caseUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        优秀案例
      </a>
    )

    if (completeCount == 0) {
      // 未开始任务
      return {
        showChart: false,
        actionText: examples,
        renderComp: <UnStart />,
        title: '新店专属'
      }
    } else if (undoneCount > 0) {
      // 任务进行中
      return {
        showChart: false,
        actionText: examples,
        renderComp: (
          <Tasking undoneCount={undoneCount} completionRate={completionRate} />
        ),
        title: '新店专属'
      }
    } else if (supportEndTime > 0 && isEmpty(exposureList)) {
      // 明日开启
      return {
        showChart: false,
        actionText: examples,
        renderComp: <Tomorrow />,
        title: '新店专属'
      }
    } else if (supportEndTime == 0) {
      // 新店扶持已结束
      return {
        showChart: true,
        actionText: '',
        title: '店铺曝光量'
      }
    } else {
      // 扶持中
      return {
        showChart: true,
        actionText: '',
        title: '店铺曝光量'
      }
    }
  }

  getChartData = taskPageData => {
    const x = []
    const y = []
    ;(taskPageData.exposureList || []).forEach(item => {
      x.push(item.countDate)
      y.push(item.value)
    })

    return {
      x,
      y
    }
  }

  getOption = taskPageData => {
    const { x, y } = this.getChartData(taskPageData)
    const color = params => {
      return params.dataIndex % 2 == 0
        ? new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#fff'
            },
            {
              offset: 1,
              color: '#F1F7FE'
            }
          ])
        : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#fff'
            },
            {
              offset: 1,
              color: '#F6FCFE'
            }
          ])
    }

    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: params => {
          const { value, axisValue, seriesName } = params[0]
          return (
            axisValue +
            '<br />' +
            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#F6FCFE">' +
            '</span>' +
            seriesName +
            '：' +
            value
          )
        }
      },
      toolbox: {
        show: false
      },
      xAxis: {
        type: 'category',
        data: x,
        splitLine: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          color: '#999',
          fontSize: 14
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#999',
          fontSize: 14
        },
        splitLine: { show: false },
        axisLine: { show: false },
        axisTick: { show: false }
      },
      series: [
        {
          name: '曝光量',
          type: 'bar',
          data: y,
          barMaxWidth: 67,
          itemStyle: {
            normal: {
              color
            }
          }
        },
        {
          name: '曝光量',
          type: 'line',
          symbol: 'circle',
          symbolSize: 12,
          smooth: true,
          data: y,
          itemStyle: {
            normal: {
              borderWidth: 2,
              borderColor: '#fff',
              color: '#3072F6',
              shadowColor: '#90B3F7',
              shadowBlur: 6,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              lineStyle: {
                color: '#CAE2FE',
                width: 3
              }
            }
          }
        }
      ]
    }
  }

  render() {
    const { taskPageData } = this.props.store
    const { showChart, actionText, title, renderComp } = this.getStatus(
      taskPageData
    )
    const noChartBgStyle = !showChart
      ? {
          background: `linear-gradient(180deg,rgba(255,255,255,0.6) 0%,rgba(255,255,255,1) 100%) , url("//qnm.hunliji.com/o_1d6ahj8qpbl1f2a179065e1gia9.png") no-repeat`,
          backgroundSize: 'cover'
        }
      : {}

    return (
      <>
        <Panel
          title={
            <>
              <span style={{ color: '#333333' }}>{title}</span>
            </>
          }
          extra={actionText}
          style={{ flex: 1 }}
          contentStyle={{
            height: 290,
            paddingTop: 0,
            ...noChartBgStyle
          }}
        >
          {showChart ? (
            <ReactEcharts
              style={{ height: 290, margin: 0 }}
              option={this.getOption(taskPageData)}
            />
          ) : (
            <div className="center">{renderComp}</div>
          )}
        </Panel>
      </>
    )
  }
}

// 任务未开始
function UnStart() {
  return (
    <div className={styles.unStart}>
      <img
        src={'//qnm.hunliji.com/o_1d6udb1oq1otfjdjt0e9f1607g.png'}
        width="24"
      />
      <div className={styles.topTxt}>新店专属</div>
      <div className={styles.desc}>
        <CheckCircleOutlined />
        简单5步教你极速开店
      </div>
      <div className={styles.desc}>
        <CheckCircleOutlined />
        新商家流量扶持免费获取
      </div>
    </div>
  )
}

// 任务进行中
function Tasking({ undoneCount, completionRate }) {
  return (
    <div className={styles.unStart}>
      <img
        src={'//qnm.hunliji.com/o_1d6udb1oq1otfjdjt0e9f1607g.png'}
        width="24"
      />
      <div className={styles.topTxt}>
        仅差<span className={styles.undoneNum}>{undoneCount}</span>步即可开启流量扶持
      </div>
      {completionRate && (
        <div className={styles.desc}>你已超过{completionRate}%的商家进度</div>
      )}
    </div>
  )
}

// 明日开启
function Tomorrow() {
  return (
    <div className={styles.unStart}>
      <img
        src={'//qnm.hunliji.com/o_1d6udb1oq1otfjdjt0e9f1607g.png'}
        width="24"
      />
      <div className={styles.topTxt}>曝光流量明日正式开启</div>
    </div>
  )
}
